import {useState} from "react";
import {Box, Button, Chip, Dialog, DialogContent, Typography} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ShoppingBagRoundedIcon from "@mui/icons-material/ShoppingBagRounded";
import WifiOffRoundedIcon from "@mui/icons-material/WifiOffRounded";
import useDoubleTap from "../hooks/useDoubleTap";
import {useKioskLang} from "../context/KioskSessionContext";
import {KIOSK_LANGS} from "../i18n";

//語言縮寫：切換鈕空間有限，用短標籤
const SHORT_LABELS = {zh: "中", en: "EN", ja: "日"};

export default function KioskHeader({systemData, method, tableNumber, cartCount = 0, onBack, onCart, onHome, online = true}) {
  const [homeOpen, setHomeOpen] = useState(false);
  const {lang, setLang, tr} = useKioskLang();
  const tapLogo = useDoubleTap(() => onHome && setHomeOpen(true));   //連點兩下 Logo 結束這次點餐回首頁（登出在首頁 Logo）

  const goHome = () => {
    setHomeOpen(false);
    onHome();
  };

  return (
    <Box component="header" sx={{height: 92, flex: "0 0 92px", px: 3, display: "flex", alignItems: "center", gap: 2, bgcolor: "rgba(255,253,249,.96)", borderBottom: "1px solid rgba(80,55,40,.1)", pt: "env(safe-area-inset-top, 0px)"}}>
      {onBack ? <Button variant="text" startIcon={<ArrowBackRoundedIcon/>} onClick={onBack} sx={{minWidth: 120}}>{tr("back")}</Button> : null}
      <Box sx={{display: "flex", alignItems: "center", gap: 1.5, minWidth: 0}}>
        <Box component="img" src={systemData?.store_image || "/logo.png"} onClick={tapLogo} alt="店家 Logo" sx={{width: 56, height: 56, objectFit: "contain", borderRadius: "50%", userSelect: "none", WebkitTouchCallout: "none"}}/>
        <Typography noWrap sx={{fontSize: 25, fontWeight: 900}}>{systemData?.store_name || tr("selfOrder")}</Typography>
      </Box>
      <Box sx={{ml: "auto", display: "flex", alignItems: "center", gap: 1.5}}>
        <Box sx={{display: "flex", p: .4, borderRadius: 99, bgcolor: "#F3E7D9"}}>
          {KIOSK_LANGS.map((option) => (
            <Button key={option.code} onClick={() => setLang(option.code)} sx={{minWidth: 48, minHeight: 40, px: 1.25, borderRadius: 99, fontSize: 15.5, fontWeight: 900, color: lang === option.code ? "#FFF" : "text.secondary", bgcolor: lang === option.code ? "primary.main" : "transparent", "&:hover": {bgcolor: lang === option.code ? "primary.main" : "rgba(80,55,40,.08)"}}}>
              {SHORT_LABELS[option.code] ?? option.label}
            </Button>
          ))}
        </Box>
        {!online && <Chip icon={<WifiOffRoundedIcon/>} label={tr("offline")} color="error" sx={{fontSize: 16, fontWeight: 800}}/>}
        {method && <Chip label={Number(method) === 3 ? `${tr("dineIn")}${tableNumber ? ` · ${tr("tableChip", {n: tableNumber})}` : ""}` : tr("takeout")} sx={{height: 44, px: 1, fontSize: 17, fontWeight: 900, bgcolor: "#F3E7D9"}}/>}
        {onCart && <Button variant="contained" startIcon={<ShoppingBagRoundedIcon/>} onClick={onCart} sx={{minWidth: 150}}>{tr("cartButton", {n: cartCount})}</Button>}
      </Box>
      <Dialog open={homeOpen} onClose={() => setHomeOpen(false)} maxWidth="xs" fullWidth>
        <DialogContent sx={{p: 4, textAlign: "center"}}>
          <HomeRoundedIcon sx={{fontSize: 56, color: "primary.main"}}/>
          <Typography sx={{fontSize: 26, fontWeight: 900, mt: 1}}>{tr("endOrderTitle")}</Typography>
          <Typography sx={{fontSize: 17, color: "text.secondary", mt: 1.5}}>{tr("endOrderText")}</Typography>
          <Box sx={{display: "grid", gap: 1.5, mt: 3}}>
            <Button variant="contained" onClick={goHome} sx={{minHeight: 60, fontSize: 20}}>{tr("goHome")}</Button>
            <Button variant="outlined" onClick={() => setHomeOpen(false)} sx={{minHeight: 60, fontSize: 20}}>{tr("keepOrdering")}</Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
